import React from "react";
import TableCard from "../common/TableCard";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import { pinnedProjects } from "../../constants/columns/dashboard/pinnedProjects";
import { useNavigate } from "react-router-dom";
import useProjectFacade from "../../facade/project.Facade";

interface IPinnedProjects {
    handlePinned?: any;
}

const PinnedProjects: React.FC<IPinnedProjects> = ({ handlePinned }) => {
    const { pinData, pinLoading, loading }: any = useAppSelector((state) => state?.myProjects);
    const navigate = useNavigate();
    const { getUpdatedSelectedProject } = useProjectFacade();

    const handleNavigate = (row: any) => {
        navigate(`/project-details/projectID=${row?.projectID}`);
        (async () => {
            await getUpdatedSelectedProject({
                projectID: row?.projectID,
                projectName: row?.projectName,
                caseID: ""
            });
        })()
    };

    return (
        <TableCard
            title={"Pinned projects"}
            data={pinData}
            columns={[
                ...pinnedProjects({
                    handlePinned,
                    handleNavigate
                }),
            ]}
            isLoading={pinLoading || loading}
            errorMessage="No pinned projects"
        />
    );
};

export default PinnedProjects;
